// Whether the board's aside (preview / quickview panel) is on screen right now.

/**
 * The view-settings panel and the aside are both right-hand side surfaces on the same row. With
 * both open the collection is squeezed into whatever is left between them, which on Table reads as
 * a broken layout rather than two panels.
 *
 * Presentation only: the aside is HIDDEN, never closed. `$panelClosed` (session dismissal) and
 * `view.showPreview` (persisted switch) stay untouched, so the aside comes back exactly as it was
 * when the view editor closes.
 */
export function boardAsideVisible(panelOpen: boolean, viewSettingsOpen: boolean): boolean {

  return panelOpen && !viewSettingsOpen;
}
